import { Theme, defaultTheme } from '../theme';

export function cvar(key: keyof Theme) {
    return `var(--ss-${key}, ${defaultTheme[key]})`;
}
